import React, { useEffect } from 'react';
import { Form, Input, Button, Card, Typography } from 'antd';
import { UserOutlined, MailOutlined, LockOutlined, IdcardOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import useDocumentTitle from '../hooks/useDocumentTitle';

const { Title, Text } = Typography;

const Register: React.FC = () => {
  useDocumentTitle('注册');
  const [form] = Form.useForm();
  const { register, state } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.authenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [state.authenticated, navigate]);

  const onFinish = async (values: any) => {
    const success = await register(values);
    if (success) {
      navigate('/dashboard', { replace: true });
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '20px' }}>
        <Card style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <Title level={2} style={{ color: '#1890ff', marginBottom: '8px' }}>
              创建账户
            </Title>
            <Text type="secondary">注册商标管理系统</Text>
          </div>

          <Form
            form={form}
            name="register"
            onFinish={onFinish}
            autoComplete="off"
            size="large"
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: '请输入登录名!' },
                { pattern: /^[a-z0-9_]{3,30}$/i, message: '登录名仅能包含字母、数字、下划线(3-30位)' }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="登录名（用于登录，例如 zhangsan）"
              />
            </Form.Item>

            <Form.Item
              name="display_name"
              rules={[{ max: 255, message: '显示名称长度不能超过 255 个字符' }]}
            >
              <Input
                prefix={<IdcardOutlined />}
                placeholder="显示名称（可中文，例如 张三）"
              />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: '请输入邮箱地址!' },
                { type: 'email', message: '请输入有效的邮箱地址!' }
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="邮箱地址"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: '请输入密码!' },
                { min: 8, message: '密码至少8个字符!' }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="密码"
              />
            </Form.Item>

            <Form.Item
              name="password_confirmation"
              dependencies={['password']}
              rules={[
                { required: true, message: '请确认密码!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次密码输入不一致!'));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="确认密码"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={state.loading}
                style={{ width: '100%' }}
              >
                注册
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">已有账户？</Text>
            <Link to="/login" style={{ marginLeft: '8px' }}>立即登录</Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Register;
